/**
 * Media settings API client (BFF: `/api/v1/store/settings/media`).
 *
 * Image rules, variants, banners and CDN (→ web-media-service).
 */
import { apiClient } from '@/shared/api';
import type { MediaSettings, UpdateMediaSettingsRequest } from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/media';

export const getMediaSettings = async (): Promise<MediaSettings> =>
  (await apiClient.get<MediaSettings>(BASE)).data;

export const updateMediaSettings = async (
  body: UpdateMediaSettingsRequest,
): Promise<MediaSettings> => (await apiClient.put<MediaSettings>(BASE, body)).data;
